import { contain } from 'react-container-helper';
import { connect } from 'react-redux';

import HotelSelector from './component';

const initState = ({ hotel }) => ({
	selectedHotel: hotel,
});

const mapSetStateToProps = (
	{ selectedHotel },
	{
		...props,
		onSelect,		
	},
	setState,
) => ({
	selectedHotel,
	
	...props,

	onSelect(option) {
		setState({ selectedHotel: option.value });
		onSelect(option);
	},
});

const componentContainer = contain(initState, mapSetStateToProps)(HotelSelector);

const mapStateToProps = (
	{ hotel: { hotel, hotelData, hotelList } },
	{ withHomeSelection }
) => ({
	hotel: {
		id: hotelData[hotel].id,
		label: hotelData[hotel].name,
		value: hotel,
	},
	hotelList: withHomeSelection ? hotelList : hotelList.filter(hotelName => hotelName !== 'main'),
	hotelData,
});

export default connect(mapStateToProps)(componentContainer);



// WEBPACK FOOTER //
// ./src/components/molecules/HotelSelector/index.js